import { useTranslation } from 'react-i18next';
import { DynamicFormProvider, TemplateConfig } from './DynamicFormContext';
import DynamicSmartFlowContent from './DynamicSmartFlowContent';
import { useDetectedCountry } from './hooks/useDetectedCountry';
import { useQuery } from '@tanstack/react-query';

interface DynamicSmartFlowProps {
  config: TemplateConfig;
}

function useDetectUserCountry() {
  return useQuery({
    queryKey: ['detect-user-country'],
    queryFn: async (): Promise<string | null> => {
      const response = await fetch('https://api.country.is/');
      if (response.ok) {
        const data = await response.json();
        return data.country_code || data.country || null;
      }
      return null;
    },
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60, // 60 minutes
    retry: 1,
  });
}

export function DynamicSmartFlow({ config }: DynamicSmartFlowProps) {
  const { i18n } = useTranslation();
  const locale = i18n.language;
  //Todo: improve country detection by combining timezone, locale, and server hints

  const { data: detectedCountry } = useDetectUserCountry();
  const resolvedCountry = useDetectedCountry(locale, detectedCountry || undefined);
  return (
    <DynamicFormProvider config={config} detectedCountry={resolvedCountry}>
      <DynamicSmartFlowContent />
    </DynamicFormProvider>
  );
}

export default DynamicSmartFlow;
